<template>
  <div id="EquipmentCurrentStatus">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Repair History</div>
          <div class="web-action-btn btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportEnrichReports()">
              <i class="fp-export"></i> Compare
            </a>
          </div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'repairHistory'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'repairHistory'" :position="'top'">
                </custom-pagination>

                <!-- <vue-good-table
                        mode="remote"
                        ref="repairHistoryTable"
                        title="repairHistory"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: 50,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                        :search-options="{
                        enabled: false,
                        }"
                        :select-options="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        >
                    </vue-good-table> -->
                    <div class="vgt-responsive">
                      <v-table :data="rows" :class="'vgt-table bordered'" :hideSortIcons="true">
                        <thead slot="head">
                          <template v-for="(col,ind) in userColumns">
                            <template v-if="col.sortable == false">
                              <th :key="'col_'+ind" :id="col.field" v-show="!col.hidden">{{ col.label }}</th>
                            </template>
                            <template v-else>
                              <th :key="'col_'+ind" :id="col.field" class="sorting" @click="onSortChangeReports($event)" v-show="!col.hidden">{{ col.label }}</th>
                            </template>
                          </template>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                            <tr v-for="row in displayData">
                              <template v-for="(col,ind1) in userColumns">
                                  <td :key="ind1" v-show="!col.hidden">{{ row[col.field] }}</td>
                              </template>
                            </tr>
                        </tbody>
                      </v-table>
                    </div>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// 
// 
// 

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

import SmartTable from 'vuejs-smart-table'
Vue.use(SmartTable)

export default {

  name: "RepairHistory",
  metaInfo(){
       return {
         title : 'Repair History | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:'',
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Repair Facility',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
        label: "Unit Number",
        field: "unit_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Misc. Unit",
        field: "misc_unit",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Unit", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Serial Number",
        field: "vin",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
          label: 'Customer Name',
          field: 'cust_name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
        label: "Alias Unit",
        field: "customer_unit_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Customer Number",
        field: "cust_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Current Unit Facility",
        field: "assigned_facility",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        width: '90px',
      },
      {
        label: "Contract Type",
        field: "conType",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
      },
      {
        label: "Equipment Pool",
        field: "pool",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
      },
      {
        label: "Equipment Group",
        field: "group",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
      },
      {
        label: "Equipment Group Description",
        field: "group_desc",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "WO Number",
        field: "work_order_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "WO Status",
        field: "work_order_status",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Group", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ['Approved','Closed','Open','In Progress','Review'],
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "WO Line #",
        field: "line_number",
        filterable: true,
        fpFieldType:"integer",
        // type:'number',
        hidden:false,
      },
      {
        label: "WO Line Sts",
        field: "line_status",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Group", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ['Closed','Open','In Progress','Review'], // dropdown (with selected values) instead of text input
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Billable",
        field: "billable_code",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Group", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [{text:'B | Billable (A/R)',value:'B'},{text:'S | Non-Billable (Skip)',value:'S'}],
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "WO Open Date",
        field: "open_date",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "WO Closed Date",
        field: "close_date",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "WO Approval Date",
        field: "approval_date",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },

      {
          label: 'Total Labor Cost',
          field: 'labor_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px'
      },
      {
          label: 'Total Part Cost',
          field: 'parts_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Total Other Cost',
          field: 'other_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Total Line Cost',
          field: 'total_line_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Internal Cost',
          field: 'internal_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'External Cost',
          field: 'external_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Billable Cost',
          field: 'billable_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Non-Billable Cost',
          field: 'non_billable_cost',
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Labor Revenue',
          field: 'labor_revenue',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Parts Revenue',
          field: 'part_revenue',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Other Revenue',
          field: 'other_revenue',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Discount',
          field: 'discount',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Invoice Line Amount',
          field: 'total_revenue',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Invoice PST Amount',
          field: 'inv_pst_amount',
          fpFieldType:"integer",
          type : 'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Invoice GST/VAT Amount',
          field: 'inv_gst_amount',
          sortable: false,
          fpFieldType:"integer",
          type : 'number',
          filterable: false,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Priority Code',
          field: 'priority',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },

      {
          label: 'Reason Code (WO Line)',
          field: 'reason_code',
          sortable: false,
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Reason Description (WO Line)',
          field: 'reason_name',
          sortable: false,
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Work Order Line',
          field: 'component',
          sortable: false,
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Task Code',
          field: 'task',
          fpFieldType:"text",
        //   sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Task Description',
          field: 'task_description',
          fpFieldType:"text",
        //   sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'VMRS Component Desc',
          field: 'vmrs_description',
          fpFieldType:"text",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
        label: "Program Code",
        field: "program_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Complaint Comment (includes WORKOR line comments)",
        field: "complaint",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Cause Comment",
        field: "cause",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Correction Comment",
        field: "correction",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Vendor Name",
        field: "vendor",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Sublet PO Number",
        field: "po_number",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Sublet PO Line Number",
        field: "po_line_number",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Sublet Invoice Gross Amount",
        field: "sublet_invoice_amount",
        filterable: true,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
      },
      {
        label: "Sublet Invoice Date",
        field: "sub_inv_dt",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "Sublet Invoice Number",
        field: "sub_inv_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "AP Acct Year",
        field: "account_year",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "AP Acct Period",
        field: "account_period",
        filterable: true,
        fpFieldType:"integer",
        hidden:false,
      },
      {
        label: "Vendor Company Code",
        field: "company_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Vendor Code",
        field: "vendor_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Vendor Suffix",
        field: "vendor_suffix",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Vendor State",
        field: "vendor_state",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Warranty Claim #",
        field: "claim_number",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Warranty Status",
        field: "warranty_status",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Warranty Cost Claimed",
        field: "cost_claimed",
        filterable: true,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
      },
      {
        label: "Warranty Hours Claimed",
        field: "hours_claimed",
        filterable: false,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
        sortable :  false,
      },
      {
        label: "Warranty Collected",
        field: "warranty_collected",
        filterable: false,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
        sortable:false
      },
      {
        label: "Warranty Code",
        field: "warranty_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "WO Meter Type1",
        field: "section1",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Reading1",
        field: "reading1",
        filterable: true,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
      },
      {
        label: "UOM1",
        field: "uom1",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Meter Type2",
        field: "section2",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Reading2",
        field: "reading2",
        filterable: true,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
      },
      {
        label: "UOM2",
        field: "uom2",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Meter Type3",
        field: "section3",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Reading3",
        field: "reading3",
        filterable: true,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
      },
      {
        label: "UOM3",
        field: "uom3",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Override Facility",
        field: "override_facility",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Create User",
        field: "created_by",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "WO Create Date",
        field: "created_at",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "WO Create Time",
        field: "wo_create_time",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false,
      },
      {
        label: "Unit Year",
        field: "year",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Misc Unit Meter Reading",
        field: "misc_reading",
        filterable: false,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
        sortable : false,
      },
      {
        label: "Misc Unit UOM",
        field: "misc_uom",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable: false,
      },
      {
        label: "Equipment Type",
        field: "asset_type",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
      },
      {
        label: "Equipment Type Description",
        field: "asset_type_description",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Parent Unit Number",
        field: "parent_unit_number",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false,
      },
      {
        label: "Equip Sts",
        field: "unit_status",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
      },
      {
        label: "Mfg Code",
        field: "manufacturer",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Mfg Name",
        field: "manufacturer_name",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Billing Customer",
        field: "bill_cust_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Billing Customer Name",
        field: "bill_cust_name",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Equipment Model Code",
        field: "model",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Equipment In Service Date",
        field: "date_in_service",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "Reason Code (WO Header)",
        field: "wo_reason",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable: false,
      },
      {
        label: "Reason Description (WO Header)",
        field: "wo_reason_desc",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable: false,
      },
      {
        label: "Customer PO",
        field: "customer_po",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Diff Billing Customer?",
        field: "diff_customer",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Customer", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        },
        sortable:false
      },
      {
        label: "Unit Aging Year",
        field: "aging_year",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Header Comments",
        field: "wo_comment",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Actual Hours",
        field: "actual_hours",
        filterable: false,
        fpFieldType:"integer",
        type : 'number',
        hidden:false,
        sortable:false
      },
      {
        label: "Months In Service",
        field: "month_in_service",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Part Failure Code",
        field: "failure_code",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Repair Feature Description 1",
        field: "feature_desc1",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Repair Feature Value 1",
        field: "feature_value1",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Repair Feature Description 2",
        field: "feature_desc2",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Repair Feature Value 2",
        field: "feature_value2",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO Line Date Created",
        field: "wo_line_created_at",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "WO Line Time Created",
        field: "wo_line_created_time",
        filterable: false,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "Reason Reference For (Hdr)",
        field: "reason_ref_for",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Reason Reference (Hdr)",
        field: "reason_ref",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "WO Approval User",
        field: "approved_by",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        sortable: false,
      },
      {
        label: "Super Equipment Type",
        field: "sup_equip_type",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Super Equipment Type Description",
        field: "sup_equip_type_desc",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Sublet PO Vendor City",
        field: "po_vendor_city",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Unit Description",
        field: "vehicle_name",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "Equipment Region Code",
        field: "equip_region_code",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable: false,
      },
       {
        label: "Equipment Region Description",
        field: "equip_region_desc",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable: false,
      },
      {
        label: "Cost Reporting Code",
        field: "item_code",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Cost Reporting Code Description",
        field: "item_name",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Days To Close",
        field: "close_days",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Invoice Hours",
        field: "inv_hrs",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "WO create user Name",
        field: "wo_create_usr_name",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: "Work Order Approval User Name",
        field: "wo_app_usr_name",
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        sortable:false
      },
      {
        label: 'VMRS Code and Description',
        field: 'vmrs_code',
        fpFieldType:"text",
        sortable: false,
        filterable: true,
        hidden:false,
        width:'90px'
      },
      {
        label: 'Include Comments',
        field: 'include_comments',
        fpFieldType:"option",
        sortable: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Include Comments", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [{text:'Yes (Y)',value:'yes'},{text:'No (N)',value:'no'}], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        },
        hidden:true,
        width:'90px'
      }
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'repair_history_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  created: function() {
      this.serverParams.stopRequest = true;
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
    //this.loadList();
  },

  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.outofserviceHistoryTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      $(".loader").css("display","block");
      var date = new Date();
      var offset = date.getTimezoneOffset();
      var selectedRows = [];
      // var data = this.$refs['repairHistoryTable'].selectedRows;
      // for ( var i = 0; i < data.length; i++ ) {
      //     selectedRows.push(this.$refs['repairHistoryTable'].selectedRows[i].id)
      // }

      $.ajax({
        url: process.env.ROOT_API + "/repair-history-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          sort: self.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {

          self.loading = false;
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue" || self.action == "compare-with-enrich" || self.action == "compare-with-enrich_queue" ) {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" || self.action == "compare-with-enrich") {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();

            } else {

                if (data.content.row != undefined) {

                    self.totalRecords = data.content.totalRecords;
                    self.rows = data.content.row;

                }
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'equipment-current-status')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/RepairHistoryReport.vue